<template>
    <div class="parent">
        <banner v-bind:bannerObj="bannerObj"></banner>
        <div class="container">
            <div class="content">
                <div class="curmbsLink">
                    <router-link to="/products">产品与服务</router-link>
                    <span> > </span>
                    <span>金融系统开发</span>
                </div>
                <div class="address">
                    <div>
                        <b>GET</b>
                        <span>金融系统开发</span>
                        <p>一站式解决跨境交易中各类金融系统的开发和技术维护问题，为客户提供从平台前端到后台系统管理、从风控管理到售后技术服务的全方位解决方案。 </p>
                    </div>
                </div>
                <div class="textWrap">
                    <span>基本介绍</span>
                    <p>（1）货币交易、汇兑互联网解决方案</p>
                    <p>我们为您提供货币交易、汇兑系统解决方案，您可以通过系统的实时汇率报价，选择最优的货币兑换方案。</p>
                    <p>（2）资金清算系统互联网解决方案</p>
                    <p>通过我们提供的资金清算系统，您可以和您的代理商、分销商灵活有序地分享利息，轻松管理全平台的交易和账务，合规高效得解决多级账户资金管理问题。</p>
                    <p>（3）跨境资金清算网络实现方案</p>
                    <p>通过我们提供的行业内领先的跨境资金清算系统，可为客户轻松实现外汇资金的归集下拨、自动控制净流入和流出限额、办理经常项目集中收付汇、轧差净额结算业务等跨境资金管理功能，满足您实现本外币、境内外全球现金管理的服务需求。</p>
                    <p>（4）外部资金集中清算互联网解决方案</p>
                    <p>我们为您提供外部资金集中清算系统，通过这个系统，助推企业在境外实现资金的集中管控,提高资金的使用效率和降低成本,提高企业的经济效益。</p>
                </div>
            </div>
        </div>
        <footer>
            <footContent></footContent>
        </footer>
    </div>
</template>

<style lang="scss">
    .parent{
        background-color: #fff;
        .container {
            width: 1200px;
            margin: 0 auto;
            padding-top: 64px;
        }
        .content { margin-bottom: 80px; }
        .curmbsLink {
            width: 100%;
            line-height: 30px;
            margin-bottom: 20px;
            a { color: rgba(50,50,50, 0.3); }
            a:hover { color: #323232; }
        }
        .address {
            width: 100%;
            height: 450px;
            margin-bottom: 60px;
            background: url('../assets/images/photograph.png') no-repeat;
            background-size: auto 100%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: center;
            position: relative;
            > div:after {
                content: '';
                position: absolute;
                bottom: -2px;
                right: 50px;
                z-index: 1;
                width: 162px;
                height: 70px;
                background: #FEBD00;
                box-shadow: 0 0 50px rgba(0,0,0,0.2);
                border-top-left-radius: 45px;
                border-bottom-right-radius: 45px;
            }
            > div {
                width: 717px;
                height: 364px;
                background: #fff;
                border-top-left-radius: 45px;
                border-bottom-right-radius: 45px;
                box-shadow: 0 0 40px rgba(0,0,0,0.15);
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: center;
                b, span, p { width: 80%; }
                b {
                    display: block;
                    font-size: 48px;
                    font-weight: 800;
                    margin-bottom: 20px;
                }
                span {
                    display: block;
                    font-size: 30px;
                    font-weight: bold;
                    text-indent: 40px;
                    position: relative;
                    margin-bottom: 40px;
                }
                span:after {
                    content: '';
                    width: 12px;
                    height: 12px;
                    background: #FEBD00;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    margin: auto;
                    z-index: 1;
                }
                p { font-size: 20px; color: #323232; line-height: 30px;}
            }
        }
        .textWrap {
            span {
                display: block;
                font-size: 30px;
                text-indent: 40px;
                margin-bottom: 40px;
                position: relative;
            }
            span:after {
                content: '';
                width: 18px;
                height: 18px;
                background: #FEBD00;
                position: absolute;
                left: 0;
                top: 10px;
                z-index: 2;
            }
            span:before {
                content: '';
                width: 18px;
                height: 18px;
                background: #cbcbcb;
                position: absolute;
                left: 6px;
                top: 4px;
                z-index: 1;
            }
            p { line-height: 30px; }
        }
    }

</style>


<script>
import store from '../vuex'
import DetailBanner from '../components/DetailBanner'
import FootContent from "../components/FootContent.vue";
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/products.png'),
            text: 'PRODUCTS & SOLUTIONS',
        }
      }
  },
  components:{
    'banner': DetailBanner,
    'footContent': FootContent,
  },
  store,
}
</script>

